<template>
  <div class="footer">
    <div class="btn-list">
      <div
        v-for="(item, index) in footerBtnList"
        class="btn-item"
        :key="index"
        :class="activePage === item.page && 'active'"
        @click="handleFooterClick(item.page)"
      >{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
import { COMPANY_PAGE_TYPE } from '@/constant/company'
import { deviceType } from '@/utils/common'
import _ from 'lodash'
import { msdPcJobListRouteMap } from '../../../msdCustomUrl/pc/route'
import { msdMobileJobListRouteMap } from '../../../msdCustomUrl/mobile/route'

export default {
  props: {
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      required: true
    },
    activePage: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    msdJobListRouteMap () {
      return deviceType.isMobile ? msdMobileJobListRouteMap : msdPcJobListRouteMap
    },
    footerBtnList () {
      const list = []
      if (this.data.branding_page?.i18nName) {
        list.push({
          label: this.data.branding_page.i18nName,
          page: COMPANY_PAGE_TYPE.BRANDING
        })
      }
      if (this.data.has_custom_mobile_landing_page && this.data.landing_page?.i18nName) {
        list.push({
          label: this.data.landing_page.i18nName,
          page: COMPANY_PAGE_TYPE.LANDING
        })
      }

      list.push({
        label: this.$t('admin.company.customLandingPage.label.viewJobs'),
        page: null
      })

      return list
    }
  },
  created () {
  },
  methods: {
    handleFooterClick (page) {
      if (this.isPreview) {
        return
      }

      if (!page) {
        this.goToJobListPage()
        return
      }
      this.changePageParams(page)
    },

    goToJobListPage () {
      const companyId = this.company.id
      if (this.isMSDCustom) {
        const route = _.get(this.msdJobListRouteMap, companyId)
        this.$router.push({ path: route.path, query: this.$route.query })
      } else {
        this.$router.push({ path: `/mobile-web-more-jobs/${companyId}`, query: this.$route.query })
      }
    },
    changePageParams (page) {
      const isNavigationDuplicated = this.$route.params.page === page || this.$route.meta?.pageType === page
      if (isNavigationDuplicated) {
        return
      }

      if (this.isMSDCustom) {
        const pagePath = page === COMPANY_PAGE_TYPE.BRANDING ? 'about' : 'careers'
        this.$router.push({ path: `/msdchina/${pagePath}`, query: this.$route.query })
      } else {
        const params = {
          ...this.$route.params,
          page: page
        }
        this.$router.push({ params, query: this.$route.query })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 50px;
  background-color: #fff;

  .btn-list {
    background-color: #fff;
    border-top: 1px solid #ddd;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    height: 50px;
    width: 100%;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .btn-item {
      flex: 1;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;

      & + .btn-item {
        border-left: 1px solid #ddd;
      }

      &.active {
        color: var(--custom-color, #fe883a);
      }
    }
  }
}
</style>
